import React, { useEffect, useState } from "react";
import {
  Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack, Table, Spinner, FormControl, FormSelect, Badge, Popover,
  OverlayTrigger, Modal, InputGroup 
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { DatatableWrapper, TableBody, TableHeader } from "react-bs-datatable";
import Select from "react-select";
import PubSub from "pubsub-js";
import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/WebRouting";
import trasportApi from "../../api/trasportApi";
import { formatDate, getUserDetails } from "../../utils/helper";
import { forEach } from "rsuite/esm/internals/utils/ReactChildren";
import Confirm from "../Confirm";
import Main from "../layout/Main";
import moment from "moment";
// import CustomerModal from "../contact/CustomerModal";
// import audioUrl from '../../assets/sounds/notification_sound.mp3';
// import Notification from "../layout/common/Notification";
// Define initial errors i.e. required field and their message
const initialErrors = {
  contact_id: validationMessages.supplier.required,
  //   financial_year_id: validationMessages.financialYear.required,
};

const initialProductsLineItems = {
  sr_no: 1,
  product_id: null,
  quantity_used: "",
  product_qty: 0,
  service_id: null,
  owner_id: null,
  product_price: 0,
  saloon_service_price : 0,

};

const initialValue = {
  service_date: formatDate(new Date()),
  service_price: 0,
};

const ServiceOrderEdit = () => {

  console.log('ServiceOrderEdit CALL');
  const location = useLocation();
  const navigate = useNavigate();
  const [unreadMsgCount, setUnreadMsgCount] = useState(0);//add by shahir hussain
  const [messages, setMessages] = useState(0);
  const [showNotification, setShowNotification] = useState(false);
  const [showBellAlert, setShowBellAlert] = useState(false);
  const [refreshNotification, setRefreshNotification] = useState(new Date());
  // serviceOrder state
  const [serviceOrder, setServiceOrder] = useState(
    location?.state ? location?.state : initialValue
  );
  

  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  // useEffect(() => { console.log('errors', errors) }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  const [assignUsers, setAssignUsers] = useState([]);

  // contacts(references)
  const [contacts, setContacts] = useState([]);
  // financial year(references)
  const [financials, setFinancials] = useState([]);
  // Categories
  const [categories, setCategories] = useState([]);

  const [products, setProducts] = useState([]);
  // const [subCategories, setSubCategories] = useState([]);
  // purchase line items state
  const [purchaseLineItems, setPurchaseLineItems] = useState([]);
  // changed or effected rows state
  const [changedRows, setChangedRows] = useState([]);

  // changed or effected rows state
  const [comparingProducts, setComparingProducts] = useState(null);
  const [showComparingProducts, setShowComparingProducts] = useState(false);
  const [showCompareHelper, setShowCompareHelper] = useState(false);

  const [selectedProductsIds, setSelectedProductsIds] = useState(
    Array.from({ length: products.length }, () => "")
  );

  // delete modal show state
  const [deleteModalShow, setDeleteModalShow] = useState(false);

  // delete record state
  const [deleteRecord, setDeleteRecord] = useState(() => () => { });
  //added by shahir hussain for customer modal 08-05-2025
  const [showModal, setShowModal] = useState(false);
  const [vechicleOption, setOptionVechicle] = useState({});
  const [selectedVechicle, setSelectedVechicle] = useState({});

console.log("state == ",location.state)

  useEffect(() => {
    function init() {
      fetchContacts();
      fetchProducts();
      fetchedCategories();
      fetchData();
      fetchServiceLineItems();
      fetchUsers();
      // fetchSubCategories();
      // getUserDetails();
      // fetchAllVehicles();
    }
    init();
  }, []);

  useEffect(() => {
    setPurchasePrice();
    console.log("purchaseLineItems use Effect call huaa", purchaseLineItems);
  }, [purchaseLineItems]);

   async function fetchUsers(){
    let resultedUsers = await trasportApi.fetchUsers();
    console.log("resultedUsers == ",resultedUsers)
    // resultedUsers = resultedUsers.filter(user => user.isactive === true )//added by shahir hussain
      resultedUsers &&
        Array.isArray(resultedUsers) &&
        setAssignUsers(
          resultedUsers.map((user) => ({
            value: user.id,
            label: user.username,
          }))
        );
   }

  async function fetchContacts() {
    const vechicleRec = await trasportApi.fetchAllVehicles();
  
      // Vehicle API Data.
      if (vechicleRec && vechicleRec.length) {
        let uniqueVehicles = new Map();

        vechicleRec.forEach((item) => {
          if (!uniqueVehicles.has(item.vehicle_number)) {
            uniqueVehicles.set(item.vehicle_number, {
              value: item.id,
              label: item.vehicle_number,
            });
          }
        });

        let ar = Array.from(uniqueVehicles.values());

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.vehicle_id);
          setSelectedVechicle(acc);
        }

        setOptionVechicle(ar);
      } else {
        setOptionVechicle([]);
      }

  }
  
  // async function fetchAllFinancialYears() {
  //   const fetchedFinancialYears = await trasportApi.fetchAllFinancialYears();
  //   Array.isArray(fetchedFinancialYears) &&
  //     setFinancials(
  //       fetchedFinancialYears?.map((fetchedFinancialYear) => ({
  //         id: fetchedFinancialYear?.id,
  //         name: `${fetchedFinancialYear?.name || ""}`,
  //         financialData: fetchedFinancialYear,
  //       }))
  //     );
  // }
  async function fetchedCategories() {
    const fetchedCategories = await trasportApi.fetchAllCategory();
    console.log("fetchedCategories", fetchedCategories);
    Array.isArray(fetchedCategories) && setCategories([...fetchedCategories]);
  }

  async function fetchProducts() {
    const fetchedProducts = await trasportApi.fetchProducts();
    console.log("fetchedProducts", fetchedProducts);
    Array.isArray(fetchedProducts) && setProducts([...fetchedProducts]);
  }
  // async function fetchSubCategories() {
  //   const fetchedSubCategories = await trasportApi.fetchAllSubCategory();
  //   console.log("fetchedSubCategories", fetchedSubCategories);
  //   Array.isArray(fetchedSubCategories) && setSubCategories([...fetchedSubCategories]);
  // }

  const fetchData = async () => {
    if (serviceOrder?.id && location.hasOwnProperty("pathname")) {
      serviceOrder.id = location.pathname.split("/")[2];
      let result = await trasportApi.fetchServiceOrderById(serviceOrder.id);
      console.log("result", result);
      if (result) {
        setServiceOrder(result);
      } else {
        setServiceOrder({});
      }
    }
  };

  async function fetchServiceLineItems() {
    if (serviceOrder?.id) {
      const fetchServiceLineItems = await trasportApi.fetchServiceLineItemsByParentId(serviceOrder.id);
      console.log("fetchServiceLineItems Edit",fetchServiceLineItems);
      Array.isArray(fetchServiceLineItems) &&
        setPurchaseLineItems([...fetchServiceLineItems]);
    } else {
      setPurchaseLineItems([{ ...initialProductsLineItems }]);
    }
  }

  // onChange Handler
  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log(e.target);

    


    // setValidated(true);
    setServiceOrder((prev) => ({ ...prev, [name]: value }));
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (serviceOrder?.vehicle_id) {
      if (serviceOrder?.vehicle_id == "") {
        setErrors((prev) => ({
          ...prev,
          vehicle_id: { message: validationMessages.supplier.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["vehicle_id"];
          return { ...prev };
        });
      }
    }

    if (!serviceOrder?.vehicle_id) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please Select Vechicle Name",
      });
      isError = true;
    }

    // if (!serviceOrder?.owner_id) {
    //   PubSub.publish("RECORD_ERROR_TOAST", {
    //     title: "Required",
    //     message: "Please Select Assign User Name",
    //   });
    //   isError = true;
    // }



    return isError;
  };


  const checkRequiredLineItemsFileds = () => {
    
    let isError = false;
    let newErrors = {};
    purchaseLineItems.forEach((item, index) => {
      console.log("item", item);
      // if (!item?.owner_id) {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "Required",
      //     message: 'Please Provie Assign User',
      //   });
      //   isError = true;
      // }
      //else 
      if (!item?.category_id) {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Required",
          message: validationMessages.categoryName.required,
        });
        isError = true;
      }
      // else if (!item?.sub_category_id) {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "Required",
      //     message: 'Please provide sub category name',
      //   });
      //   isError = true;
      // }

      //comment this by shahir hussain for stop validation
      // else if (!item?.product_id) {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "Required",
      //     message: validationMessages.productName.required,
      //   });
      //   isError = true;
      // }
      // else 
      // else if (item?.product_qty === 0 || item?.product_qty == "") {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "INVALID",
      //     message: "Please Provide Valid Product Quantity",
      //   });
      //   isError = true;
      // }

      //comment this by shahir hussain for stop validation
      // else if (item?.quantity_used == 0 || item?.quantity_used == "") {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "INVALID",
      //     message: "Please Provide a valid Quantity Used.",
      //   });
      //   isError = true;
      // }

      //comment this by shahir hussain for stop validation
      // else if (item?.product_price === 0 || item?.product_price == "") {
      //   PubSub.publish("RECORD_ERROR_TOAST", {
      //     title: "INVALID",
      //     message: "Please Provide Valid  Product Price",
      //   });
      //   isError = true;
      // }
      else if (item?.saloon_service_price === 0 || item?.saloon_service_price == "") {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "INVALID",
          message: "Please Provide Valid  Service Price",
        });
        isError = true;
      }
    });
    return isError;
  };

  // PubSub.publish("RECORD_ERROR_TOAST", {
  //   title: "Invalid",
  //   message: "Stock not available",
  // });

  // onSubmit handler
  const handleSubmit = async (e) => {
    console.log("handle submit == ",serviceOrder)
    const UniqueChangedRows = [...new Set(changedRows.map((item) => item.id))]
      .map((item) => ({ id: item }))
      .concat(
        [...new Set(changedRows.map((item) => item.sr_no))].map((item) => ({
          sr_no: item,
        }))
      );
    console.log("UniqueChangedRows", UniqueChangedRows);

    e.preventDefault();

    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }

    // if (checkRequiredLineItemsFileds()) {
    //   setValidated(true);
    //   return;
    // }

    // if (Object?.keys(errors)?.length != 0) {
    //   setValidated(true);
    //   return;
    // }
    //Insert purchase Line item
    // console.log('UniqueChangedRows', UniqueChangedRows);
    const record = { ...serviceOrder };
    delete record.contact_name;
    delete record.financial_name;
    delete record.email;
    delete record.phone;
    delete record.street;
    delete record.owner_name;

    record.service_price = record?.service_price ? record.service_price : 0;

    // record.advance_percentage = record?.advance_percentage
    //   ? record.advance_percentage
    //   : 0;

    // record.pi_amount = record?.pi_amount ? record.pi_amount : 0;
    // //========= Logic to perform Create or Edit ======
    if (record.id) {

      console.log('Updated == ', record);
      const result = await trasportApi.saveServiceOrder(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        UniqueChangedRows.forEach(async (row) => {
          if (row?.id) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.id == row.id
            );
            console.log("for Update in update", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              // recordPurchaseLineItem.purchase_order_id = record.id;
               recordPurchaseLineItem.service_id = record.id;
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.images;
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.createdbyname;
              delete recordPurchaseLineItem.owner_name;
              delete recordPurchaseLineItem.sub_category_name;
              recordPurchaseLineItem.product_qty = recordPurchaseLineItem?.product_qty == "" ? recordPurchaseLineItem.product_qty = 0 : recordPurchaseLineItem.product_qty;

              console.log(
                "update case recordPurchaseLineItem ==>",
                recordPurchaseLineItem
              );
              const result = await trasportApi.saveServiceOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          } else if (row?.sr_no) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.sr_no == row.sr_no
            );
            console.log("for insert in update", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.images;
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.images;
              delete recordPurchaseLineItem.owner_name;
              delete recordPurchaseLineItem.sub_category_name;
              recordPurchaseLineItem.product_qty = recordPurchaseLineItem?.product_qty == "" ? recordPurchaseLineItem.product_qty = 0 : recordPurchaseLineItem.product_qty;
              // recordPurchaseLineItem.purchase_order_id = record.id;
               recordPurchaseLineItem.service_id = record.id;
              console.log(
                "create recordPurchaseLineItem ==>",
                recordPurchaseLineItem
              );
              const result = await trasportApi.createServiceOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          }
        });
        navigate(`${ROUTES.SERVICE_ORDER.LIST}/${record?.id}`, {
          state: record,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      console.log('Created service record', record);
      const resultPurchaseOrder = await trasportApi.createServiceOrder(
        record
      );
      if (resultPurchaseOrder?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        UniqueChangedRows.forEach(async (row) => {
          if (row?.id) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.id == row.id
            );
            console.log("for Update in create", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.image;
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.owner_name;
              delete recordPurchaseLineItem.sub_category_name;
              recordPurchaseLineItem.product_qty = recordPurchaseLineItem?.product_qty == "" ? recordPurchaseLineItem.product_qty = 0 : recordPurchaseLineItem.product_qty;
              // recordPurchaseLineItem.purchase_order_id = resultPurchaseOrder.id;
               recordPurchaseLineItem.service_id = resultPurchaseOrder.id;
              const result = await trasportApi.saveServiceOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          } else if (row?.sr_no) {
            const recordPurchaseLineItem = purchaseLineItems.find(
              (purchaseLineItem) => purchaseLineItem?.sr_no == row.sr_no
            );
            console.log("for insert in create", recordPurchaseLineItem);
            if (recordPurchaseLineItem) {
              delete recordPurchaseLineItem.category_name;
              delete recordPurchaseLineItem.image;
              delete recordPurchaseLineItem.sku;
              delete recordPurchaseLineItem.owner_name;
              delete recordPurchaseLineItem.sub_category_name;
              recordPurchaseLineItem.product_qty = recordPurchaseLineItem?.product_qty == "" ? recordPurchaseLineItem.product_qty = 0 : recordPurchaseLineItem.product_qty;
              // recordPurchaseLineItem.purchase_order_id = resultPurchaseOrder.id;
               recordPurchaseLineItem.service_id = resultPurchaseOrder.id;
              const result = await trasportApi.createServiceOrderLineItem(
                recordPurchaseLineItem
              );
              if (result?.success) {
              } else {
                PubSub.publish("RECORD_ERROR_TOAST", {
                  title: "Record Update Error",
                  message: result?.errors,
                });
              }
            }
          }
        });
        navigate(`${ROUTES.SERVICE_ORDER.LIST}/${resultPurchaseOrder.id}`, {
          state: resultPurchaseOrder.data,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: resultPurchaseOrder?.errors,
        });
      }
    }
  };

  const handleCancel = () => {
    if (serviceOrder.id) {
      navigate(`${ROUTES.SERVICE_ORDER.LIST}/${serviceOrder.id}`, {
        state: serviceOrder,
      });
    } else {
      navigate(ROUTES.SERVICE_ORDER.LIST);
    }
  };

  const addPurchaseLineItems = () => {
    setPurchaseLineItems((prev) => [
      ...prev,
      { ...initialProductsLineItems, sr_no: prev.length + 1 },
    ]);
  };

  // const [imagesMap, setImagesMap] = useState({});
  // const fetchPrimaryImages = async (e, row) => {
  //   try {
  //     if (!row?.product_id) return;
  //     const productImageResult = await trasportApi.fetchPrimaryImages(
  //       row.product_id
  //     );
  //     if (!productImageResult?.id) return;
  //     const productImageData = await trasportApi.downloadFiles(
  //       productImageResult.id,
  //       "ProductImages"
  //     );

  //     if (!productImageData) return;

  //     const reader = new FileReader();
  //     reader.readAsDataURL(productImageData);
  //     reader.onloadend = () => {
  //       const base64data = reader.result;

  //       setImagesMap((prev) => ({
  //         ...prev,
  //         [row.product_id]: [...(prev[row.product_id] || []), base64data], // Store images per product_id
  //       }));

  //       setPurchaseLineItems((prev) =>
  //         prev.map((purchaseLineItem) =>
  //           purchaseLineItem.id === row.id
  //             ? {
  //               ...purchaseLineItem,
  //               images: [...(prev[row.product_id] || []), base64data],
  //             }
  //             : purchaseLineItem
  //         )
  //       );
  //     };
  //   } catch (error) {
  //     console.error("Error fetching image:", error);
  //   }
  // };

  //added by shahir hussain for notification 29-05-2025
  const formatMessage = (mystr) => {
    let oldStr = mystr;
    mystr = mystr.substring(1);
    var arry = mystr.split(" @");
    var returnArr = [];

    for (var a of arry) {
      var obj = {};
      var value = a.substring(a.lastIndexOf("[") + 1, a.lastIndexOf("]"));
      var key = a.substring(a.lastIndexOf("(") + 1, a.lastIndexOf(")"));
      obj[`username`] = value;
      obj[`id`] = key;
      if (key) returnArr.push(obj);
    }

    for (var a of returnArr) {
      oldStr = oldStr.replace(
        `@[${a.username}](${a.id})`,
        `<a href="/users/${a.id}">${a.username}</a>`
      );
    }

    return oldStr;
  };

  //added by shahir hussain for notification 29-05-2025
    const messageList = (open, play) => {
      // console.log("task");
      async function init() {
        let result = await trasportApi.fetchUnreadMessages();
        //let tasks = [];
        //  console.log("tasks.length", tasks)
        if (result && result?.length > 0) {
          result.forEach((message) => {
            message.description = formatMessage(message.description);
          });
  
  
          const readMessages = result.filter((message) => message.status === "New");
          setUnreadMsgCount(readMessages.length);
  
          setMessages(result);
          setShowNotification(open);
          setShowBellAlert(!open);
  
          if (play) {
            // playBellSound();
          }
        } else {
          setMessages([]);
          setUnreadMsgCount(0);
          setShowNotification(open);
        }
      }
      init();
    };
  
    // const playBellSound =async () => {
    //   const audio = new Audio(audioUrl);
    //   console.log('Audio result', await audio.play());
    // };

  //added by shahir hussain for notification 29-05-2025
  const closeNotification = () => {
    setShowNotification(false);
  };

  //added by shahir hussain for notification 29-05-2025
  const openNotificationArea = () => {
    console.log("showNotification == ",showNotification)
    // if (!false) messageList(true, true);
    // else 
    setShowNotification(false);

    setShowBellAlert(false);
  };

  const handlePurchaseLineItemChange = async (e, row) => {
  console.log("ROW E", e);
  console.log("row?.product_id", row?.product_id);
  console.log("row?", row);
  console.log("e?.target?.name", e?.target?.name);
  console.log("fieldkey", e?.target?.fieldKey);

  // Check and handle product_id logic
  if (e?.target?.fieldKey) {
    const fetchedData = await trasportApi.fetchInventory();
    if (fetchedData === null) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "INVALID",
        message: "No Inventory Available",
      });
      return;
    }

    const inventory = fetchedData.find(stock => stock.product_id === e?.target?.value);
    const notificationResult = await trasportApi.fetchInventoryNotification(inventory);

    if (notificationResult) {
      openNotificationArea();
    }

    if (inventory?.stock_available == 0) {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "INVALID",
        message: "No Stock Available",
      });

      setPurchaseLineItems((prev) => {
        prev.forEach((purchaseLineItem) => {
          if (purchaseLineItem?.id == row.id) {
            delete purchaseLineItem["product_name"];
            delete purchaseLineItem["product_id"];
          }
        });
        return [...prev];
      });

      return;
    }
  }

  // ✅ Accept both standard and manual updates
  if (e?.target?.name || e?.target?.manual) {
    const key = e?.target?.name || e?.target?.manual;
    const value = e?.target?.value;

    if (row?.id) {
      setPurchaseLineItems((prev) => {
        prev.forEach((purchaseLineItem) => {
          if (purchaseLineItem?.id == row.id) {
            purchaseLineItem[key] = value;
          }
        });
        return [...prev];
      });
      setChangedRows((prev) => [...prev, { id: row.id }]);
    } else {
      setPurchaseLineItems((prev) => {
        prev.forEach((purchaseLineItem) => {
          if (purchaseLineItem?.sr_no == row.sr_no) {
            purchaseLineItem[key] = value;
          }
        });
        return [...prev];
      });
      setChangedRows((prev) => [...prev, { sr_no: row.sr_no }]);
    }
  }
};

  // const handlePurchaseLineItemChange = async (e, row) => {
    
  //       console.log("ROW E", e);
  //       console.log("row?.product_id", row?.product_id);
  //       console.log("row?", row);
  //       console.log("e?.target?.name", e?.target?.name);
  //       console.log("fieldkey", e?.target?.fieldKey);

  //       //add this code by shahir hussain 

  //       if(e?.target?.fieldKey){
  //         console.log("in if come == ",e?.target?.value)
  //         const fetchedData = await trasportApi.fetchInventory();
  //         console.log("inventory product data == ",fetchedData)
  //         if(fetchedData === null){
  //             PubSub.publish("RECORD_ERROR_TOAST", {
  //             title: "INVALID",
  //             message: "No Inventory Available",
  //           });
  //           return
  //         }
  //         const inventory = fetchedData.find(stock => stock.product_id === e?.target?.value)
  //         console.log("inventory == ",inventory)
  //         //Add this step by shahir hussain for inventory notification
  //         const notificationResult = await trasportApi.fetchInventoryNotification(inventory);
  //         console.log("check notification == ",notificationResult)
  //         if(notificationResult){
  //           console.log("notificationResults == ",notificationResult)
  //           openNotificationArea();
  //         }
  //         console.log("notificationResult == ",notificationResult)
  //         console.log("stock == ",inventory)
  //         console.log("stock available == ",inventory?.stock_available)

  //         if(inventory?.stock_available == 0){
  //           PubSub.publish("RECORD_ERROR_TOAST", {
  //             title: "INVALID",
  //             message: "No Stock Available",
  //           });
  //           setPurchaseLineItems((prev) => {
  //             prev.forEach((purchaseLineItem) => {
  //               if (purchaseLineItem?.id == row.id) {
  //                 //changes by shahir hussain 19-06-2024
  //                 // purchaseLineItem["product_name"] = '';
  //                 // purchaseLineItem["product_id"] = '';
  //                 delete purchaseLineItem["product_name"];
  //                 delete purchaseLineItem["product_id"];
  //               }
  //             });
  //             return [...prev];
  //           });
  //           return;
  //         }
  //       }

  //       if (e?.target?.name) {
  //         console.log("coming")
  //         if (row?.id) {
  //           console.log("coming in if")
  //           setPurchaseLineItems((prev) => {
  //             console.log("coming prev == ",prev)
  //             prev.forEach((purchaseLineItem) => {
  //               if (purchaseLineItem?.id == row.id) {
  //                 purchaseLineItem[e.target.name] = e?.target?.value;
  //               }
  //             });
  //             return [...prev];
  //           });
  //           setChangedRows((prev) => [...prev, { id: row.id }]);
  //         } else {
  //           console.log("coming in else")
  //           setPurchaseLineItems((prev) => {
  //             console.log("coming prev == ",prev)
  //             prev.forEach((purchaseLineItem) => {
  //               console.log("sh checked == ",e.target.name)
  //               console.log("sh value == ",e.target.value)

  //               if (purchaseLineItem?.sr_no == row.sr_no) {
  //                 purchaseLineItem[e.target.name] = e?.target?.value;
  //               }
  //             });
  //             return [...prev];
  //           });
  //           setChangedRows((prev) => [...prev, { sr_no: row.sr_no }]);
  //         }
  //       }


  // };


  const getPurchasePrice = () => {
    const purchasePriceArr = purchaseLineItems?.map((purchaseLineItem) => {
      console.log("purchaseLineItem == ", purchaseLineItem);
  
      const price = parseFloat(purchaseLineItem?.product_price);
      const servicePrice = parseFloat(purchaseLineItem?.saloon_service_price);
  
      if (!isNaN(price) && !isNaN(servicePrice)) {
        console.log('product_price:', price);
        console.log('saloon_service_price:', servicePrice);
        return price + servicePrice;
      } else {
        return 0;
      }
    });
  
    if (!Array.isArray(purchasePriceArr) || purchasePriceArr.length === 0) return 0;
  
    // Total sum
    const totalPrice = purchasePriceArr.reduce((prev, value) => prev + (value || 0), 0);
    return totalPrice;
  };
  
  
  const setPurchasePrice = () => {
    const purchasePrice = getPurchasePrice();
    console.log("purchasePrice", purchasePrice);
    purchasePrice != null &&
      purchasePrice != undefined &&
      setServiceOrder((prev) => ({ ...prev, service_price: purchasePrice }));
  };

  // const fetchProductsForCompare = async () => {
  //   if (serviceOrder.contact_id) {
  //     const result = await trasportApi.compareProductsByContactId(
  //       serviceOrder.contact_id
  //     );
  //     if (!result && result?.errors) {
  //       PubSub.publish("RECORD_ERROR_TOAST", {
  //         title: "Record Update Error",
  //         message: result.errors || "",
  //       });
  //     } else {
  //       setComparingProducts(result);
  //       setShowComparingProducts(true);
  //     }
  //   } else {
  //     PubSub.publish("RECORD_ERROR_TOAST", {
  //       title: "Record Update Error",
  //       message: "Supplier is required",
  //     });
  //   }
  // };

  const closeComparePrice = () => {
    setShowComparingProducts(false);
  };

  const onVendorInfoSelect = (e) => {
    const value = e.value;
    const label = e.label;

    const contactData = contacts
      .filter((contact) => contact.id == e.value)
      ?.at(0)?.contactData;

    const serviceOrder = {};
    serviceOrder.email = contactData?.email || "";
    serviceOrder.phone = contactData?.phone || "";
    serviceOrder.street = contactData?.street || "";

    setServiceOrder((prev) => ({ ...prev, ...serviceOrder }));
    handleChange({ target: { name: "contact_id", value: e.value } });
    handleChange({ target: { name: "contact_name", value: e.label } });
  };

  const purchaseLineItemsHeader = [
    {
      title: "S.No",
      prop: "sr_no",
    },
    
    // {
    //   title: "Assigned User",
    //   prop: "owner_id",
    //   cell: (row) => (
    //      <Form.Group>
                     
    //                   <Select
    //                     required
    //                     className={`${row?.owner_id
    //                       ? "custom-select-valid"
    //                       : "custom-select-invalid"
    //                       }`}
    //                     name="owner_id"
    //                     onChange={(e) => {
    //                       handlePurchaseLineItemChange({ target: { name: "owner_id", value: e.value } }, row);
    //                       handlePurchaseLineItemChange({ target: { name: "owner_name", value: e.label } }, row);
    //                     }}
    //                     options={assignUsers}
    //                     value={row?.owner_id ? { value: row?.owner_id || "", label: row?.owner_name || "" } : ""}
    //                      menuPortalTarget={document.body}
    //                     styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
    //                   />                    
    //                 </Form.Group>
    //   ),
    // },
    
{
  title: "Tyre Type",
  prop: "tyreType",
  cell: (row) => (
    <Form.Group>
      <Select
        placeholder="-- Select Tyre Type --"
        name="tyreType"
        value={
          row?.tyreType
            ? { label: row?.tyreType, value: row?.tyreType }
            : ""
        }
        onChange={(e) =>
          handlePurchaseLineItemChange(
            { target: { name: "tyreType", value: e.value } },
            row
          )
        }
        options={[
          "Front Axle",
          "Drive Axle",
          "Tag Axle",
          "Lift Axle",
          "Trailer Axle",
          "Pusher Axle",
          "Steer Tyre",
          "Spare Tyre",
          "Tubeless",
          "Tube Type",
          "New",
          "Used",
          "Retread",
        ].map((item) => ({ label: item, value: item }))}
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
      />
    </Form.Group>
  ),
},    {
      title: "Category",
      prop: "category_id",
      cell: (row) => (
        <Form.Group>
          <Select
            required
            className={`${row?.category_id
                ? "custom-select-valid"
                : "custom-select-invalid"
              }`}
            placeholder="Select Category"
            options={categories?.map((category) => ({
              value: category?.id,
              label: category?.name,
            }))}
            onChange={(e) => {
              handlePurchaseLineItemChange(
                { target: { name: "category_id", value: e.value } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "category_name", value: e.label } },
                row
              );
              // Reset product & SKU when category changes
              handlePurchaseLineItemChange(
                { target: { name: "product_id", value: null } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "product_name", value: "" } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "sku", value: "" } },
                row
              );
              handlePurchaseLineItemChange(
                { target: { name: "sub_category_id", value: null } },
                row
              );
            }}
            value={
              row?.category_id
                ? { value: row?.category_id, label: row?.category_name || "" }
                : ""
            }
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
          />
        </Form.Group>
      ),
    },
    {
      title: "Product",
      prop: "product_id",
      fieldKey: "product",
      cell: (row) => {
       
        const filteredProducts = products || [];
        
        return (
          <Form.Group>
            <Select
              placeholder="Select Product"
              options={filteredProducts.map((product) => ({
                value: product?.id,
                label: `${product?.product_name} (${product?.sku})`, // Show product name + SKU
              }))}
              onChange={(e) => {
                const selectedProduct = products.find(
                  (product) => product.id === e.value
                );
                handlePurchaseLineItemChange(
                  { target: { name: "product_id", value: e.value,fieldKey: "product", } },
                  row
                );
                handlePurchaseLineItemChange(
                  {
                    target: {
                      name: "product_name",
                      value: selectedProduct?.product_name || "",
                    },
                  },
                  row
                );
                handlePurchaseLineItemChange(
                  {
                    target: { name: "sku", value: selectedProduct?.sku || "" },
                  },
                  row
                );
              }}
              value={
                row?.product_id
                  ? {
                    value: row?.product_id,
                    label: `${row?.product_name} (${row?.sku})`,
                  }
                  : ''
                }
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 1111 }) }}
                />
              </Form.Group>
            );
          },
    },
    {
      title: "Start KM",
      prop: "start_km",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            type="number"
            placeholder="Start KM"
            value={row?.start_km || ''}
            onChange={(e) => {
              const value = Number(e.target.value || 0);

              handlePurchaseLineItemChange(
                { target: { name: 'start_km', value } },
                row
              );

              // Calculate total_running_avg if end_km is already filled
              if (row?.end_km || row?.end_km === 0) {
                const total = value >= row.start_km ? value - row.start_km : 0;

                handlePurchaseLineItemChange(
                  { target: { name: 'total_running_avg', value: total } },
                  row
                );
              }
            }}
          />
        </Form.Group>
      ),
    },
    {
        title: "End KM",
        prop: "end_km",
        cell: (row) => (
          <Form.Group>
            <Form.Control
              type="number"
              placeholder="End KM"
              value={row?.end_km || ''}
              onChange={(e) => {
                const value = Number(e.target.value || 0);

                handlePurchaseLineItemChange(
                  { target: { name: 'end_km', value } },
                  row
                );

                // Calculate total_running_avg if start_km is already filled
                if (row?.start_km || row?.start_km === 0) {
                  const total = value >= row.start_km ? value - row.start_km : 0;
                  handlePurchaseLineItemChange(
                    { target: { name: 'total_running_avg', value: total } },
                    row
                  );
                }
              }}
            />
          </Form.Group>
        ),
      },

      {
  title: "Running Avg (KM)",
  prop: "total_running_avg",
  cell: (row) => (
    <Form.Group>
      <Form.Control
        type="number"
        placeholder=""
        value={row?.total_running_avg || ''}
        disabled
      />
    </Form.Group>
  ),
},




    {
      title: "Quantity Used %",
      prop: "quantity_used",
      cell: (row) => (
<Form.Group style={{ position: 'relative', width: '100%' }}>
    <div
    style={{
      display: 'flex',
      alignItems: 'center',
      backgroundColor: row?.product_id ? '#fff' : '#E9ECEF',
      border: '1px solid #ced4da',
      borderRadius: '4px',
      paddingRight: '8px',
      width: '100%',
      height: '38px', // match Form.Control height
    }}
  >
    <Form.Control
      disabled={row?.product_id ? false : true}
      // required
      placeholder="Quantity"
      name="quantity_used"
      value={row?.quantity_used || ''}
      onChange={(e) => {
        let value = e.target.value.replace(/[^0-9.]/g, '');
        console.log("per value == ",value)

        if (value === '' || parseFloat(value) <= 100) {
          handlePurchaseLineItemChange({ target: { name: 'quantity_used', value } }, row);
        }
      }}
      style={{
        border: 'none',
        boxShadow: 'none',
        height: '100%',
        paddingRight: 0,
      }}
    />
    <span
      style={{
        marginLeft: 'auto',
        color: '#6c757d',
        fontSize: '0.875rem',
        userSelect: 'none',
        pointerEvents: 'none',
      }}
    >
      %
    </span>
  </div>
  
</Form.Group>


      ),
    },
    {
      title: "Product Price",
      prop: "product_price",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            // required
            disabled={row?.product_id ? false : true}
            className={`${row?.product_price
              ? "custom-select-valid"
              : "custom-select-invalid"
              }`}
            placeholder="Enter Price"
            type="number"
            name={`product_price`}
            value={row?.product_price || ''}
            onKeyDownCapture={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            onChange={(e) => {
              handlePurchaseLineItemChange(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    {
      title: "Service Price",
      prop: "saloon_service_price",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            required
            className={`${row?.saloon_service_price
              ? "custom-select-valid"
              : "custom-select-invalid"
              }`}
            placeholder="Enter Price"
            type="number"
            name={`saloon_service_price`}
            value={row?.saloon_service_price || ''}
            onKeyDownCapture={(e) =>
              ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
            }
            onChange={(e) => {
              handlePurchaseLineItemChange(e, row);
            }}
          />
        </Form.Group>
      ),
    },
    

    {
      title: "Total Price",
      prop: "id",
      cell: (row) => (
        <Form.Group>
          <Form.Control
            disabled
            value={
              (Number(row.product_price) || 0) + (Number(row.saloon_service_price) || 0)
              // (Number(row.product_qty) || 0) * (Number(row.product_price) || 0)
            }
          />
        </Form.Group>
      ),
    },
   
    {
      'title': 'Action', 'prop': 'id', cell: (row) => {
        const deleteCallback = async () => {
          console.log('Deleted ID', row);
          if (row?.id) {
            const result = await trasportApi.deleteServiceOrderLineItemById(row.id);
            if (result?.success) {
              PubSub.publish("RECORD_SAVED_TOAST", {
                title: "Record Deleted",
                message: "Record successfully deleted",
              });
              fetchServiceLineItems();
            }
            else {
              PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Delete Error', message: result?.errors });
            }
          } else if (row?.sr_no) {
            setPurchaseLineItems([...purchaseLineItems.filter((item) => row.sr_no !== item?.sr_no)]);
            PubSub.publish("RECORD_SAVED_TOAST", {
              title: "Record Deleted",
              message: "Record successfully deleted",
            });
          }
          setDeleteModalShow(false);
        }
        return <Button variant="danger" onClick={() => { setDeleteModalShow(true); setDeleteRecord(() => deleteCallback); }}><i className="fa fa-regular fa-trash "></i></Button>
      },
    }
  ];

  useEffect(() => { console.log('deleteRecord', deleteRecord); }, [deleteRecord])

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

    //Vehicle
  const handleVehicle = (e) => {
    setSelectedVechicle(e);
    setServiceOrder({ ...serviceOrder, vehicle_id: e.value });
  };

  return (
   <>
   <Main>
     <Container className="pb-5">
      {deleteModalShow && <Confirm
        show={deleteModalShow}
        onHide={() => setDeleteModalShow(false)}
        deleteRecord={deleteRecord}
        title="Confirm delete?"
        message="You are going to delete the record. Are you sure?"
        table="purchase_line_items"
      />}

{/* added by shahir hussain */}
    {/* {showNotification && (
      <Notification
        notifications={messages}
        closeNotification={closeNotification}
        refreshNotification={refreshNotification}
        messageList={messageList}
      />
    )} */}

      <Row>
        <Col md={12}>
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item
              onClick={() => navigate(ROUTES.SERVICE_ORDER.LIST)}
            >
              Service Orders
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
            <CardHeader className="card-header" style={{ background: "#1A293B", color: "white" }}>
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {serviceOrder?.id ? (
                        <h5 className="m-0">
                          Edit Service Order{" "}
                          {serviceOrder?.purchase_order_no || ""}
                        </h5>
                      ) : (
                        <h5 className="m-0">Create Service Order</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                    {/* Add This button by shahir hussain for create customer 09-05-2024  */}
                    {/* { !location?.state?.id &&
                      <Button
                        size="sm"
                        className="btn-edit"
                        onClick={() => setShowModal(true)}
                        >
                        Create Customer
                        </Button>
                      } */}
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        variant="danger"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody className="">
                <Row lg={12} className="view-form ">
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPurchaseDate"
                      >
                        Service Date
                      </Form.Label>
                      <FormControl
                        type="date"
                        name="service_date"
                       value={serviceOrder?.service_date
                        ? moment(serviceOrder.service_date).format("YYYY-MM-DD")
                        : ''}

                        onKeyDown={(e) => e.preventDefault()}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.service_date?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                  <Form.Group className="">
                    <Form.Label className="form-view-label">Vehicle</Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Vehicle Name"
                      value={selectedVechicle}
                      onChange={handleVehicle}
                      options={vechicleOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Vehicle Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>


                  {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPiNo"
                      >
                        Customer Address
                      </Form.Label>
                      <FormControl
                        disabled
                        placeholder="Customer Address"

                        value={serviceOrder.street}

                      />

                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPiNo"
                      >
                        Customer Mobile Number
                      </Form.Label>
                      <FormControl
                        disabled
                        placeholder="Customer Mobile Number"

                        value={serviceOrder.phone}

                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicPiNo"
                      >
                        Customer Email
                      </Form.Label>
                      <FormControl
                        disabled
                        placeholder="Customer Email"
                        value={serviceOrder?.email}
                      />
                    </Form.Group>
                  </Col> */}


                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicTotalAmount"
                      >
                        Total Amount
                      </Form.Label>
                      <FormControl
                       disabled
                        name="service_price"
                        // value={
                        //   serviceOrder?.service_price != null &&
                        //     serviceOrder?.service_price != undefined
                        //     ? serviceOrder.service_price
                        //     : 0
                        // }
                        value={
                          serviceOrder?.service_price ?
                            serviceOrder?.service_price : location?.state?.service_price || 0
                        }
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors?.service_price?.message}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                      >
                        Service Type
                      </Form.Label>
                      <FormControl
                        placeholder="Enter Service Type"
                        name="service_type"
                        value={
                          serviceOrder.service_type
                            ? serviceOrder.service_type
                            : ""
                        }
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                      >
                        Remark
                      </Form.Label>
                      <FormControl
                        placeholder="Enter Remark"
                        name="remark"
                        value={
                          serviceOrder.remark
                            ? serviceOrder.remark
                            : ""
                        }
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  {/* comment by shahir hussain */}
                  {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                      >
                        Custom Invoice Number
                      </Form.Label>
                      <FormControl
                        placeholder="Enter Invoice Number"
                        name="soiree_inv"
                        value={
                          serviceOrder.soiree_inv
                            ? serviceOrder.soiree_inv
                            : ""
                        }
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col> */}


                  {/* <Col lg={6}>
                    <Form.Group>
                      <Form.Label
                        className="form-view-label"
                        
                      >
                        Assigned User
                      </Form.Label>
                      <Select
                       required
                       className={`${serviceOrder?.owner_id
                         ? "custom-select-valid"
                         : "custom-select-invalid"
                         }`}
                        name="owner_id"
                        // className={`${serviceOrder?.owner_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                        onChange={(e) => {
                          handleChange({ target: { name: "owner_id", value: e.value } });
                          handleChange({ target: { name: "owner_name", value: e.label } });
                        }}
                        options={assignUsers}
                        value={serviceOrder?.owner_id ? { value: serviceOrder?.owner_id || "", label: serviceOrder?.owner_name || "" } : ""}
                      />
                      {(errors?.owner_id?.message && (!serviceOrder.owner_id)) && <div className="feedback-invalid">
                        {errors?.owner_id?.message}
                      </div>}
                    </Form.Group>
                  </Col> */}
                </Row>
                <Row className="pb-1 mt-5">
                  <Col lg={12} className="">
                    <DatatableWrapper
                      body={
                        purchaseLineItems && Array.isArray(purchaseLineItems)
                          ? purchaseLineItems
                          : []
                      }
                      headers={purchaseLineItemsHeader}
                    >
                      <Row className="py-2">
                        <Col
                          lg={12}
                          className="d-flex justify-content-between  py-2"
                           style={{ background: "#1A293B", color: "white" }}
                        >
                          <h5 className="m-0 p-0">Service Line Items</h5>
                          <Stack direction="horizontal" gap={4}>
                            <Button
                              size="sm"
                              className="btn-save"
                              onClick={addPurchaseLineItems}
                            >
                              Add Items
                            </Button>
                          </Stack>
                        </Col>
                      </Row>
                      <Row></Row>
                      <Table
                        striped
                        className="shadow rounded checkin-table"
                        responsive
                      >
                        <TableHeader />

                        {purchaseLineItems &&
                          Array.isArray(purchaseLineItems) ? (
                          <TableBody />
                        ) : (
                          <tbody className="">
                            <tr>
                              <td colSpan={100} align="center">
                                <div>
                                  <Spinner />
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </Table>
                    </DatatableWrapper>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
  			{/* Add this customer modal by shahir hussain 09-05-2025 */}
        {/* <CustomerModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onSuccess={(contact) =>{
          console.log("Saved Contact:", contact)
          setServiceOrder((prev) => ({
            ...prev,
            contact_id: contact.id,
            contact_name: `${contact.firstname} ${contact.lastname}`,
            phone: contact.phone,
            email: contact.email || '',
            street: contact.street || ''
          }));
        }}
      /> */}
    </Container>
   </Main>
   </>
  );
};

export default ServiceOrderEdit;